<template>
  <div class="row align-items-center mt-12" v-loading="loading">
      <div class="col-sm-12 col-md-12">

            <el-form ref="formSport" :model="formSport" status-icon :rules="rules" label-position="left">
                <div class="row">

                    


                    <div class="col-sm-6">
                        <h3 class="text-dark font-weight-bold mb-5">.:KEROUGUI:.</h3>

                        <el-form-item label="Nivel" label-width="100px">
                            <el-select v-model="formSport.nivel" placeholder="Seleccionar" size="small" class="w-100">
                                <el-option label="Avanzados" value="AZ"></el-option>
                                <el-option label="Noveles" value="NV"></el-option>
                                <el-option label="Intermedios" value="I"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Categoría" label-width="100px">
                            <el-radio-group v-model="formSport.gender">
                                <el-radio :key="formSport.gender" border  :label="formSport.gender" >{{categories[formSport.gender].name}}</el-radio>
                            </el-radio-group>

                            <!--<el-select v-model="formSport.category" placeholder="Seleccionar" size="small" class="w-100">
                                <el-option label="" value=""></el-option>
                            </el-select>-->
                        </el-form-item>
                        <el-form-item label="División" label-width="120px" prop="grado">
                            <el-select v-model="formSport.grado" multiple  :multiple-limit="1" filterable placeholder="Seleccione una división de peso" class="w-100">
                                <el-option v-for="item in test" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
                            </el-select>
                        </el-form-item>

                        <!--<el-form-item v-model="formSport.grado" label="Grado" label-width="100px">
                            <el-input size="small" maxlength="3"></el-input>
                        </el-form-item>-->

                    </div>


                    <div class="col-sm-6" >

                        <h3 class="text-danger font-weight-bold mb-5">.:POOMSAE:.</h3>

                        <div class="d-flex align-items-center mb-6" v-if="!modalEdit">
                            <span class="label label-success label-inline mr-2" style="font-size: 1rem;">Deportista</span>
                            <h3 class="text-dark font-weight-bold mb-0">{{currentAcreditation.athlete}}</h3>
                        </div>

                        <el-form-item label="Modalidad" label-width="120px">
                            <el-radio-group v-model="formSport.modality">
                                <el-radio v-for="item in poomsae.modality" :key="item.id" border  :label="item.id" >{{item.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label="Poomsae" label-width="120px">
                            <el-select v-model="formSport.poomsae" :disabled="formSport.ranking" filterable placeholder="Seleccionar" size="medium" class="w-100">
                                <el-option v-for="item in poomsae.poomses" :key="item.code" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-checkbox v-model="formSport.ranking" @change="changeRanking" border size="medium" class="float-right w-50 mb-4">Danes Ranking</el-checkbox>
                        <el-alert v-if="formSport.ranking"
                            type="success"
                            description="Recuerde, solo puede participar en Poomsae o Ranking Danes"
                            show-icon>
                        </el-alert>
                    </div>
                </div>
            </el-form>

            <el-divider class="my-4"></el-divider>
            <div v-if="modalEdit">
                <div class="btn btn-sm btn-success mr-3" @click="updateSport('formSport')"><i class="el-icon-edit"></i> Actualizar</div>
                <div class="btn btn-sm btn-secondary" @click="cancelEdit"><i class="el-icon-close"></i> Cerrar</div>
            </div>
            <div v-else>
                <div class="btn btn-sm btn-success mr-3" @click="submitSport('formSport')"><i class="el-icon-arrow-right"></i> Siguiente</div>
                <div class="btn btn-sm btn-secondary" @click="cancelProcess"><i class="el-icon-close"></i> Cancelar</div>
            </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { STEP, MODAL_NEW, MODAL_EDIT } from "@/store/step.module";
import { RELEASE_ACREDITATION, REGISTER_COMPTETITION, LIST_ACREDITATION, UPDATE_COMPETITION } from "@/store/acreditation.module";
import code from "@/core/config/status.code";
import dataJson from "@/data/common";

export default {
    props: {
        idacreditation: {
            type: Number,
            default: 0,
        },
        poomsae: {
            type: Object,
            default: () => {}
        },
        kerougui: {
            type: Object,
            default: () => {}
        },
        competdata: {
            type: Object,
            default: () => []
        }
    },
    data (){
        var validaPoomse = (rule, value, callback) => {
            if (!value) {
                if(!this.formSport.ranking)
                    return callback(new Error(`Falta seleccionar el Poomsae a participar.`));
                else
                    callback();
            }else {
                callback();
            }
        };
        return{
            loading: false,
            categories : dataJson.categorie, 
            formSport:{
                ranking: false,
                poomsae: null,
                modality: null,
                statusp: this.poomsae.status,
                nivel: null,
                category: null,
                grado: null,
                statusk: this.kerougui.status
            },
            rules: {
                
            },
            test: []
        }
    },
    computed: {
        ...mapGetters(['modalNew', 'currentAcreditation', 'modalEdit']),
        /*filteredModality: function() {
            return this.poomsae.modality.filter((modali) => {
                return modali.id.match(this.formSport.modality)
            });
        }*/
    },
    beforeMount(){
        /*this.competdata.forEach(element => {
            if(element.idcmp == 'CMP0008'){
                this.formSport.ranking = (element.idtest == 'DRK') ? true : false;
                this.formSport.poomsae = (element.idtest != 'DRK') ? element.idtest : null;
                this.formSport.modality = element.idniv;
            }
        });*/

        console.log(this.competdata)
        if(this.modalEdit){
            //console.log(this.competdata[0])
            //this.formSport.nivel = this.competdata[0].idniv;
            //this.formSport.param1 = this.competdata[0].param1;
            //this.formSport.prueba = [];
            //this.formSport.gender = this.competdata[0].idcat;
            this.formSport.gender = this.competdata[0].idcat;
            this.competdata.forEach(element => {
                this.formSport.ranking = (element.idtest == 'DRK') ? true : false;
                this.formSport.poomsae = (element.idtest != 'DRK') ? element.idtest : null;
                this.formSport.modality = element.idniv;
            });
        }else{
            this.formSport.gender = this.currentAcreditation.gender
        }

        if(this.formSport.gender == 'M')
            this.test = dataJson.ky_male
        else
            this.test = dataJson.ky_female


    },
    methods:{
        submitSport(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false;
                try {
                    this.loading = true;
                    this.$store.dispatch(REGISTER_COMPTETITION,{athlete : this.currentAcreditation, cmp: this.formSport})
                    .then(() => {
                        this.$store.dispatch(LIST_ACREDITATION,{sport: 'taekwondo', data: this.currentAcreditation})
                        .then(() => {
                            this.$store.dispatch(STEP, 4);
                            this.loading = false;
                        })
                        .catch((err) => {
                            console.log('error en la lista de participantes: ' + err);
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                                this.loading = false;
                                code.Manager(err.status, 'athlete');
                            }
                        });
                    })
                } catch (error) {
                    console.log(error);
                }
            });
        },
        updateSport(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false;
                try {
                    this.loading = true;
                    this.$store.dispatch(UPDATE_COMPETITION,{slug : this.idacreditation, data: this.formSport})
                    .then(() =>{
                        this.loading = false;
                        this.$notify.success({title: 'Perefcto', message: 'Datos de competencia actualizados correctamente.'});
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                            if(err.status == 401)
                                this.$router.push({ name: "login" });
                            }
                        });
                    });
                } catch (error) {
                    console.log(error);
                }
            });
        },
        cancelProcess(){
            this.$confirm('Esto anulará el proceso de registro. Desea continuar?', 'Alerta', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                closeOnClickModal: false,
                type: 'warning'
            }).then(() => {
                try {
                    this.loading = true;
                    this.$store.dispatch(RELEASE_ACREDITATION, this.currentAcreditation.idacreditation)
                    .then((mea) => {
                        console.log(mea);
                        this.$store.dispatch(STEP, 0).then(()=>{
                            this.loading = false;
                            this.$store.dispatch(MODAL_NEW, false);
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                                this.$store.dispatch(STEP, 0).then(()=>{
                                    this.loading = false;
                                    this.$store.dispatch(MODAL_NEW, false);
                                });
                                code.Manager(err.status, 'athlete');
                            }
                        });
                    })
                    
                } catch (error) {
                    this.loading = false;
                    this.$notify.error({title: 'Error:', message: error});
                }
            }).catch(() => {});
        },
        cancelEdit(){
            this.$store.dispatch(MODAL_EDIT, false);
        },
        changeRanking(){
            //let beforeTest = (this.formSport.poomsae != null) ? this.formSport.poomsae : null;
            if(this.formSport.ranking)
                this.formSport.poomsae = null;  
            //}else{
                //this.formSport.poomsae = beforeTest;
            //}
        }
    },
    created() {

       // test
        
        //this.formSport.gender = this.competdata[0].idcat;
    }
}
</script>